import React from 'react'
import { BlockComponent } from 'lib'
import { CardContent, CardLayoutWrapper, CardTitle } from './styles'
import Image from 'next/legacy/image'
import { DashboardItem } from 'experiences/dashboard/DashboardRoot'
import { buildDashItem } from 'experiences/dashboard/DashboardRoot/lib/types'

export interface CardLayoutProps {
	graphic?: JSX.Element
	title: string | JSX.Element
	body: JSX.Element
	footer?: JSX.Element
}

export const CardLayout: BlockComponent<CardLayoutProps> = ({ graphic, body, footer, title }) => {
	return (
		<CardLayoutWrapper>
			{graphic ?? null}
			<CardTitle>{title}</CardTitle>
			<CardContent>{body}</CardContent>
			{footer ?? null}
		</CardLayoutWrapper>
	)
}

export interface CardOptions {
	imageUrl: string
	title: string
	body: string
	footer?: JSX.Element
}

export const buildStaticCard: BlockComponent<CardOptions> = ({ imageUrl, title, body, footer }) => {
	return CardLayout({
		title: title,
		graphic: <Image src={imageUrl} width="128" height="100" alt="" />,
		body: <p>{body}</p>,
		footer
	})
}

export const buildStaticDashItem = (props: CardOptions): DashboardItem =>
	buildDashItem(buildStaticCard(props) || <div />)
